import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 16px;
`

const Title = styled.h1`
  font-size: 20px;
`

const Text = styled.p`
  color: #8c8c8c;
`

const BulletList = styled.ul`
  color: #8c8c8c;
`

const NoResults = () => (
  <Wrapper data-test="noSearchResult">
    <Title>No matches found for your search criteria.</Title>
    <Text>Here are a few suggestions that might help:</Text>

    <BulletList>
      <li>Check for typos: Make sure all words are spelled correctly.</li>
      <li>Use fewer filters: Broaden your search by removing some filters.</li>
      <li>
        Expand your search area: Try a larger area or a different location.
      </li>
    </BulletList>

    <Text>{`Still can't find what you're looking for? 
    Try resetting your search to start fresh with 
    different criteria.`}</Text>
  </Wrapper>
)

export default NoResults
